
import { combineReducers } from 'redux';

import config from '../../../modules/config';
import lang from '../../../modules/lang';
import navigation from '../../../modules/navigation';
import request from '../../../modules/request';

const rootReducer = combineReducers({
    config,
    lang,
    navigation,
    request
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/components/Header/reducers/index.js